var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification"},[_c('el-button',{attrs:{"size":"small","type":"primary","nums":_vm.num,"disabled":_vm.disabled || (!_vm.enable)},on:{"click":_vm.send}},[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89f29a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/verificationButton/index.vue
// module id = null
// module chunks = 